import { Injectable } from '@angular/core';
import p from '../../../../../package.json';
import { Version } from './version';

@Injectable({ providedIn: 'root' })
export class CurrentVersionService {
  readonly current = new Version(p.version);
}
